<template>
  <div class="w-full">
    <b-row>
      <b-modal id="modal-assign" hide-footer ref="assignSubmissions" title="Assign Submission">
        <Assignment :id="taskId" :type="type" permission="can_view_legal_documents_tasks"/>
      </b-modal>
      <b-modal ref="addPRN" title="Change PRN" size="md" hide-footer>
        <AddPRN :tracking-number="application.trackingNumber"/>
      </b-modal>
      <b-modal ref="transferApplication" title="Transfer Application" size="md" hide-footer>
        <TransferTaskOwnership type="ld"/>
      </b-modal>
    </b-row>

    <b-row>
      <b-col cols="2">
        <b-form-group label="Search" label-for="form-input" class="ml-2">
        <b-form-input
            class="text-gray text-sm noFocus"
            style="padding:6px 5px;"
            v-model="search"
            type="text"
            placeholder="Search by Tracking No."
            required
            v-on:keyup.enter="fetch">
        </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Filter" label-for="date-input" class="ml-2">
          <b-form-select
            v-model="statuses"
            v-on:change="fetch"
            class="form-select noFocus text-sm text-gray">
            <b-select-option :value="null">--Filter by Status--</b-select-option>
            <b-select-option value="Draft">Draft</b-select-option>
            <b-select-option value="Pending">In Queue</b-select-option>
            <b-select-option value="Assigned">Assigned</b-select-option>
            <b-select-option value="Queried">Queried</b-select-option>
            <b-select-option value="Approved">Approved</b-select-option>
            <b-select-option value="Escalated">Escalated</b-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Date registered from" label-for="date-input" class="mb-0">
          <b-form-input
            class="text-gray text-sm noFocus ml-1"
            style="margin-top: 1px; padding:6px 5px;"
            v-model="startRegistrationDate"
            type="date"
            required
            v-on:change="fetch">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Date registered to" label-for="date-input" class="mb-0">
          <b-form-input
            class="text-gray text-sm noFocus"
            style="margin-top: 1px; padding:6px 5px;"
            v-model="endRegistrationDate"
            type="date"
            required
            v-on:change="fetch">
          </b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="2">
        <button v-if="canViewActionWithPermission('can_transfer_legal_doc_ownership')" class="bg-blue px-2 py-1 mt-2 text-white rounded-sm text-sm" @click="$refs.transferApplication.show()">
          <i class="fa fa-reply"></i> Transfer Ownership</button>
      </b-col>

      <b-col cols="2">
        <b-row>
          <b-col class="mx-auto">
            <p class="paginate-details text-center text-xs font-bold">
              <b-form-select v-model="limit" class="w-full text-xs form-select border-0 paginate-details" v-on:change="fetch">
                <b-select-option value="12">12</b-select-option>
                <b-select-option value="20">20</b-select-option>
                <b-select-option value="50">50</b-select-option>
                <b-select-option value="100">100</b-select-option>
              </b-form-select>
              <span>{{((currentPage - 1) * limit) + 1}}</span> -
              <span v-if="limit > submissions.length ">{{pagination.totalElements}}</span>
              <span v-else>{{currentPage * limit}}</span>
              of {{pagination.totalElements}}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div class="mx-auto">
      <b-progress value="100" v-if="loading"  variant="#007ac5" height="0.2rem" animated></b-progress>
    </div>
    <b-row>
      <b-col cols="12">
        <table class="min-w-full leading-normal">
          <thead>
          <tr class="border-b border-t border-grey">
            <th class="t-header">#</th>
            <th class="t-header">Tracking No.</th>
            <th class="t-header">Type</th>
            <th class="t-header" width="40%">Subject</th>
            <th class="t-header text-center">Filing Date</th>
            <th class="t-header text-center">Status</th>
            <th class="t-header text-center">Assignment</th>
            <th class="t-header text-center">Action</th>
            <th class="t-header text-center">Date Approved</th>
          </tr>
          </thead>

          <tbody>
            <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(submission, idx) in submissions" :key="idx">
              <td class="t-body">{{(currentPage - 1) * limit + idx + 1}}</td>
              <td class="t-body text-blue font-bold cursor-pointer hover:underline"
                  @click="showDetails(submission.trackingNumber)">{{submission.trackingNumber}}</td>
              <td class="t-body text-uppercase font-bold">{{cleanEntityType(submission.documentType.toLowerCase())}}</td>
              <td class="t-body text-capitalize">{{submission.subjectMatter}}</td>
              <td class="t-body text-center">
                {{dateFormat(submission.filingDate)}}
              </td>
              <td class="t-body text-center">
                <p class="text-xs px-2 py-1 text-capitalize text-center" style="background: #f1f1f1">
                  <span :class="(submission.status.toUpperCase() === 'PENDING') ? 'text-gray' :
                              (submission.status.toUpperCase() === 'DRAFT')? 'text-gray-light':
                              (submission.status.toUpperCase() === 'AWAITING_PAYMENT_CONFIRMATION')? 'text-purple':
                              (submission.status.toUpperCase() === 'FAILED')? 'text-red':
                              (submission.status.toUpperCase() === 'ASSIGNED')? 'text-blue':
                              (submission.status.toUpperCase() === 'APPROVED') ? 'text-green' :
                              (submission.status.toUpperCase() === 'QUERIED') ? 'text-orange' : ''">

                    <span v-if="submission.status.toUpperCase() === 'AWAITING_PAYMENT_CONFIRMATION'">
                      Confirming Payment
                    </span>
                    <span v-else-if="submission.status.toUpperCase() === 'PENDING'">
                      In Queue
                    </span>
                    <span v-else>
                      {{ submission.status.toLowerCase().replaceAll("_", " ") }}
                    </span>
                  </span>
                </p>
              </td>
              <td class="t-body text-center">
                <p class="text-xs px-2 py-1 text-capitalize italic text-center">
                  <span v-if="submission.assignedTo">
                    {{submission.assignedTo.firstName}}
                    {{submission.assignedTo.lastName}}
                  </span>
                  <span v-else-if="submission.escalation">
                    {{submission.escalation.toUser.firstName}}
                    {{submission.escalation.toUser.lastName}}
                  </span>
                  <span v-else>
                    Not assigned
                  </span>
                </p>
              </td>
              <td class="t-body text-center">
                <button
                  v-if="submission.status.toUpperCase() === 'AWAITING_PAYMENT_CONFIRMATION'"
                  class="bg-blue text-white px-2 py-1 rounded-sm" @click="move(submission)">
                  <i class="fa fa-reply mx-1"></i> Move to Queue <b-spinner v-if="loadingMoveTask" small></b-spinner>
                </button>
                <button
                  v-else-if="(submission.status.toUpperCase() === 'FAILED' || submission.status.toUpperCase() === 'DRAFT') && canViewActionWithPermission('can_add_prn_in_legal_documents') "
                  class="text-xs bg-blue text-white px-2 py-1 rounded-sm" @click="addPRN(submission)">
                  <i class="fa fa-plus mx-1"></i> Add PRN
                </button>
                <button
                  v-else-if="submission.status.toUpperCase() === 'ESCALATED' && canViewActionWithPermission('can_assign_legal_document_application')"
                  class="bg-blue text-white px-2 py-1 rounded-sm" @click="assignPrompt(submission, 'Escalation')">
                  <i class="fa fa-reply mx-1"></i>Assign
                </button>
                <button
                  v-else-if="submission.status.toUpperCase() === 'PENDING' && canViewActionWithPermission('can_assign_legal_document_application')"
                  class="bg-green text-white px-2 py-1 rounded-sm" @click="assignPrompt(submission, 'New')">
                  <i class="fa fa-plus mx-1"></i>Assign
                </button>
                <button
                  v-else-if="submission.status.toUpperCase() === 'ASSIGNED' && canViewActionWithPermission('can_assign_legal_document_application')"
                  class="bg-red text-white px-2 py-1 rounded-sm" @click="assignPrompt(submission, 'New')">
                  <i class="fa fa-redo mx-1"></i>Assign
                </button>
              </td>
              <td class="t-body text-center">
                {{dateTimeFormat(submission.createdAt)}}
              </td>
            </tr>
            <tr>
              <td v-if="submissions.length === 0" colspan="12" class="bg-inertgrey text-center py-1">
                <span class="text-sm">No results found</span>
              </td>
            </tr>
            <tr>
              <td v-if="hasError" colspan="12" class="bg-red text-center py-1 text-white">
                <p class="text-sm">Failed to load tasks, Try again later.</p>
                <p class="text-sm">{{errorMessage}}</p>
                <p class="text-sm">
                  <button class="bg-white text-red px-2 rounded-sm" @click="fetch">Reload <b-spinner v-if="loading" small></b-spinner></button>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row class="mx-1" v-if="pagination.totalPages > 1">
      <b-col cols="1">
        <button @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
      </b-col>
      <b-col cols="1">
        <b-row>
          <b-col cols="12">
            <p class="paginate-details text-center">
              <b-badge class="bg-blue text-white">
                {{currentPage}}/{{pagination.totalPages}}
              </b-badge>
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="1" >
        <button @click="next" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">Next</button>
      </b-col>
      <b-col cols="6"></b-col>
      <b-col cols="1">
        <b-form-select v-model="limit" class="form-select border-0 mt-1" v-on:change="fetch">
          <b-select-option value="12">12</b-select-option>
          <b-select-option value="20">20</b-select-option>
          <b-select-option value="50">50</b-select-option>
          <b-select-option value="100">100</b-select-option>
        </b-form-select>
      </b-col>
      <b-col cols="2">
        <b-row>
          <b-col class="mx-auto">
            <p class="paginate-details text-center text-xs font-bold">
              <span>{{((currentPage - 1) * limit) + 1}}</span> -
              <span v-if="limit > submissions.length ">{{pagination.totalElements}}</span>
              <span v-else>{{currentPage * limit}}</span>
              of {{pagination.totalElements}}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex"
import router from "@/router";
import Assignment from "@/views/home/commons/Assignment";
import AddPRN from "@/views/home/commons/AddPRN";
import TransferTaskOwnership from "@/views/home/commons/TransferTaskOwnership";
import moment from "moment/moment";

export default {
  name: "AllLegalDocumentSubmissions",
  components: { TransferTaskOwnership, AddPRN, Assignment},
  data(){
    return{
      loading:false,
      loadingMoveTask: false,
      currentPage:1,
      limit:10,
      submissions:[],
      pagination:{
        totalElements: 0,
        totalPages:0
      },
      taskId:null,
      rows:{
        odd:"border-t border-grey hover:bg-header_grey",
        even:"border-t border-grey hover:bg-header_grey"
      },
      search:"",
      statuses: "Pending",
      application:{},
      application_prn:null,
      hasError:false,
      errorMessage:null,
      type:"legal-docs",
      startRegistrationDate: null,
      endRegistrationDate: null,
    }
  },
  mounted() {
    this.fetch()
  },
  methods:{
    ...mapActions(["submitLegalDocumentApplicationPayment", "fetchLegalDocumentSubmissions", "redoTransaction"]),
    open(trackingNumber){
      router.push("/submission/reservation/"+trackingNumber)
    },
    attachPrn() {
      this.loading.true
      let data = {
        "prn": this.application_prn,
        "trackingNumber": this.application.trackingNumber,
      }
      this.submitLegalDocumentApplicationPayment(data)
    },
    fetch(){
      let options = this.statuses
      if(this.statuses === null){
        options = "Draft,Pending,Assigned,Approved,Queried,Escalated"
      }
      if(this.search !== ""){
        this.currentPage = 1
      }
      let data = {
        search: this.search,
        statuses: options,
        page:this.currentPage,
        limit:this.limit,
        startApprovalDate: this.startRegistrationDate ? moment(this.startRegistrationDate).format('YYYY-MM-DD') : "",
        endApprovalDate: this.endRegistrationDate ? moment(this.endRegistrationDate).format('YYYY-MM-DD') : "",
      }
      this.loading = true
      this.fetchLegalDocumentSubmissions(data)
    },
    next(){
      if(this.currentPage < this.pagination.totalPages){
        this.currentPage++
        this.fetch()
      }
    },
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
        this.fetch()
      }else{
        this.warningToast("Observation", "No more data to show")
      }
    },
    addPRN(application){
      this.application = application
      this.$refs.addPRN.show()
    },
    move(application){
      let data = {
        userId: JSON.parse(sessionStorage.getItem("current_user")).userId,
        prn: application.prn
      }
      this.redoTransaction(data)
    },
    assignPrompt(data, origin){
      if(origin === "Escalation"){
        this.type = "legal-docs-as"
      }
      this.taskId = data.documentId
      this.$refs.assignSubmissions.show();
    },
    showDetails(trackingNumber){
      this.$emit("openDetails", trackingNumber)
    },
    cleanEntityType(name){
      let n = name.replaceAll("_", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
      canViewActionWithPermission(permission) {
          return this.$can(permission, "general") === true
      }
  },
  computed:{
    ...mapGetters(["getLegalDocumentTask", "getLegalDocumentDetailsErrorBox", "getLegalDocumentSubmissions", "getLegalDocumentAssignmentSuccess", "getLegalDocumentError", "getMoveTask", "getMoveTaskError"])
  },
  watch:{
    getLegalDocumentTask() {
      this.loading = false
      this.application_prn = null;
      this.successToast("Success", "PRN Attachment Successful")
      this.$refs.addPRN.hide();
      this.fetch()
    },
    getLegalDocumentDetailsErrorBox(response) {
      this.loading = false
      this.errorToast("Error", response.data.message)
    },
    getLegalDocumentSubmissions(data){
      this.loading = false
      this.submissions = data.content
      this.pagination = {
        totalPages:data.totalPages,
        totalElements:data.totalElements
      }
    },
    getLegalDocumentAssignmentSuccess(){
      this.loading = false
      this.successToast("Success", "Assignment has been completed")
      this.$refs.assignSubmissions.hide();
      this.fetch()
    },
    getLegalDocumentError(data){
      this.loading = false
      this.hasError = true
      this.errorMessage = data.message
      this.errorToast("Error", data.message)
    },
    getMoveTask(){
      this.loadingMoveTask = false
      this.successToast("Request Success", "Transaction retried")
      this.fetch();
    },
    getMoveTaskError(data){
      this.loadingMoveTask = false
      this.errorToast("Error", data.message)
    },
    getRegistrationError(data) {
      this.loading = false;
      this.hasError = true
      this.errorMessage = data.message
      this.errorToast("Error", JSON.stringify(data.message));
    },
    getNetworkStatus(message){
      this.loading = false
      this.hasError = true
      this.errorMessage = message
      this.errorToast("Network Error", message)
    },
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.verified{
  @apply text-xs font-bold;
  color: green;
  font-style: italic;
}

.unverified{
  @apply text-xs font-bold;
  color: #b80404;
  font-style: italic;
}

.assign-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-green text-green text-xs;
}

.assign-btn:hover{
  @apply bg-green text-white;
}

.de-assign-btn{
  @apply px-3 py-1 bg-white border-2 border-red text-red font-bold text-xs;
}

.de-assign-btn:hover{
  @apply bg-red text-white;
}

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>